import LCASModal from '@scripts/components/Modal';
import '@styles/app.scss';

export default class {
  /**
   * Ajax configuration
   *
   * @private
   *
   * @var {object}
   */
  #config;

  /**
   * Subscription/Unsubscription modal
   *
   * @private
   *
   * @var {LCASModal}
   */
  #modal;

  boot() {
    // set config
    this.#config = window?.licornAlertsub || null;
    if (!this.#config) {
      return;
    }

    // init modal
    this.#modal = new LCASModal(this.#config);

    // unsubscribe: auto open
    if (
      this.#config?.hash &&
      this.#config.hash === document.location.hash.substring(1)
    ) {
      this.#modal.on('modal_close', () => this.#modal.unlock(), { once: true });
      this.#modal.open('lcas_form_unsubscribe', true);
    }

    // display the modal after clicking on a trigger
    document.querySelectorAll('[data-lcas-modal]').forEach((elt) =>
      elt.addEventListener('click', (e) => {
        e.preventDefault();

        elt.disabled = true;

        this.#modal.setPostTypes(
          elt.dataset.lcasTypes ? elt.dataset.lcasTypes.split(',') : []
        );
        this.#modal.open('lcas_form_subscribe');

        elt.disabled = false;
      })
    );
  }
}
